import React, { useContext } from 'react';
// import { useIntl, defineMessages } from 'react-intl';
import { translate } from 'translations/i18n';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import LoadingSpinner from 'components/shared/LoadingSpinner';
import { Billboard } from '@companycam/slab-web';
import TasksEmptyState from 'images/TasksEmptyState.png';
import { TemplateModalContext } from '../TemplateModalContext';
import {
  MANAGE_TASK_LISTS_TEMPLATES,
  userHasPermission,
} from 'helpers/permissions';
import { useCurrentUser } from 'javascripts/hooks';

const BillboardDiv = styled.div`
  padding: 0 24px 56px 24px;
  height: calc(
    100% - 4px
  ); /* Prevents scroll due to pagination in templates list */
`;

const EmptyStateContainer = ({ loading, error, children, partner = false }) => {
  const templateModal = useContext(TemplateModalContext);

  const user = useCurrentUser();
  const canManageTemplates = userHasPermission(
    user,
    MANAGE_TASK_LISTS_TEMPLATES,
  );

  const primaryAction = (permission) => {
    return permission && !partner
      ? {
          label: translate('projects.taskList.templates.createToDo'),
          onClick: templateModal.onRequestBlankTodo,
        }
      : null;
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  if (error) {
    return (
      <BillboardDiv>
        <Billboard
          title={translate('projects.taskList.templates.error.heading')}
          iconName="alert-circle"
          color="destroy"
          primaryAction={{
            label: translate('core.errorResetButton.message'),
            onClick: templateModal.onRequestClose,
          }}
          message={translate('projects.taskList.templates.error.use')}
        />
      </BillboardDiv>
    );
  }
  if (!children)
    return (
      <BillboardDiv>
        <Billboard
          title={translate('projects.taskList.templates.empty')}
          image={{
            src: TasksEmptyState,
            alt: translate('projects.taskList.templates.empty'),
          }}
          primaryAction={primaryAction(canManageTemplates)}
          message={
            canManageTemplates && !partner
              ? translate('projects.taskList.templates.emptyMessage')
              : null
          }
        />
      </BillboardDiv>
    );

  return children;
};

EmptyStateContainer.propTypes = {
  children: PropTypes.node,
  loading: PropTypes.bool,
  error: PropTypes.bool,
  partner: PropTypes.bool,
};

export default EmptyStateContainer;
